export const copyrightYear = () => {
  const date = new Date();
  const year = date.getFullYear();
  const yearElement = document.querySelector("#copy-year");

  if (yearElement) {
    yearElement.textContent = year.toString();
  }
}